import React from 'react';
import { useLocation } from 'react-router-dom';

const Footer = () => {
    const location = useLocation();
    const showLegalButton = location.pathname !== "/free-retention-calculator";

    return (
        <footer className="bg-footer text-ink">
            <div className="mx-auto flex max-w-layout flex-col items-center justify-between gap-3 px-5 py-5 text-sm sm:flex-row">
                <div className="footer-logo">
                    <img src="/footer_logo.svg" alt="ClientBloom Logo" className="h-10" />
                </div>
                {showLegalButton && (
                    <nav className="flex gap-5 font-ui">
                        <a href="/legal" className="text-ink/60 transition-colors hover:text-ink">
                            Legal
                        </a>
                    </nav>
                )}
            </div>
        </footer>
    );
};

export default Footer;
